var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluetime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 2.33341C5.31818 2.33341 2.33341 5.31818 2.33341 9.00008C2.33341 12.682 5.31818 15.6667 9.00008 15.6667C12.682 15.6667 15.6667 12.682 15.6667 9.00008C15.6667 5.31818 12.682 2.33341 9.00008 2.33341ZM0.666748 9.00008C0.666748 4.39771 4.39771 0.666748 9.00008 0.666748C13.6024 0.666748 17.3334 4.39771 17.3334 9.00008C17.3334 13.6024 13.6024 17.3334 9.00008 17.3334C4.39771 17.3334 0.666748 13.6024 0.666748 9.00008ZM9.00008 4.00008C9.46033 4.00008 9.83342 4.37318 9.83342 4.83342V8.65492L12.0893 10.9108C12.4147 11.2362 12.4147 11.7639 12.0893 12.0893C11.7639 12.4147 11.2362 12.4147 10.9108 12.0893L8.41083 9.58933C8.25458 9.43308 8.16675 9.22108 8.16675 9.00008V4.83342C8.16675 4.37318 8.53983 4.00008 9.00008 4.00008Z",
    fill: "#533E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetime);
export default __webpack_public_path__ + "static/media/blue time.827694c1e5e3b61708ff514daa4fb7f2.svg";
export { ForwardRef as ReactComponent };